import { all, takeEvery, takeLatest } from 'redux-saga/effects'

import { TemplatesActions } from '../actions'
import { deleteTemplate } from './deleteTemplate'
import { fetchTemplates } from './fetchTemplates'
import { saveTemplate } from './saveTemplate'
import { useTemplate } from './useTemplate'

export function* templatesSaga() {
  yield all([
    // Switching workspaces mid-flight must not let the older list land last.
    takeLatest(TemplatesActions.fetch, fetchTemplates),
    takeEvery(TemplatesActions.use, useTemplate),
    takeEvery(TemplatesActions.delete, deleteTemplate),
    // The button is disabled while saving; this only guards a double dispatch.
    takeLatest(TemplatesActions.save, saveTemplate),
  ])
}
